import { EDITOR_OPTIONS } from "src/common/constants";

export const EDITOR_MARKS = [
  EDITOR_OPTIONS.UNDO,
  EDITOR_OPTIONS.REDO,
  "fontSizeOptions",
  EDITOR_OPTIONS.BOLD,
  EDITOR_OPTIONS.ITALIC,
  EDITOR_OPTIONS.UNDERLINE,
  EDITOR_OPTIONS.LINK,
  EDITOR_OPTIONS.STRIKETHROUGH,
  EDITOR_OPTIONS.HIGHLIGHT,
  EDITOR_OPTIONS.CALLOUT,
  "bulletList",
  "orderedList",
  "todoList",
  "blockquote",
  EDITOR_OPTIONS.CODE,
  "codeBlock",
  EDITOR_OPTIONS.TABLE,
  EDITOR_OPTIONS.ATTACHMENTS,
  EDITOR_OPTIONS.IMAGE_UPLOAD,
  EDITOR_OPTIONS.VIDEO_UPLOAD,
  EDITOR_OPTIONS.TEXT_COLOR,
  EDITOR_OPTIONS.EMOJI,
  EDITOR_OPTIONS.NEETO_KB_ARTICLE,
  "mentions",
];
